<template>
    <div class="df-inline-btn">
        <!-- TODO disable in preview mode -->
        <a class="btn btn-outline-secondary" :href="settings.linkUrl" target="_blank" rel="noopener">{{ settings.linkText || "Goto" }}</a>
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import type LinkAlternativeDef from "../elements/LinkAlternativeDef";
import type { LinkAlternativeSettings } from "@cs-ts/link-alternative-settings";
export default defineComponent({
    components: {
        ...components,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<LinkAlternativeDef, LinkAlternativeSettings>) {
        const base = setup<LinkAlternativeDef, LinkAlternativeSettings>(props);
        return {
            ...base.expose,
        };
    },
});
</script>
